import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { styles } from './Cell.scss';

const cx = classNames.bind(styles);

export const Cell = ({ offset, columns, children, className, ...props }) => {
  const cellClasses = [];

  // convert columns + offset props into responsive classes
  if (typeof columns === 'string') {
    cellClasses.push(`u-width-${columns}/12`);
  } else {
    Object?.entries(columns).forEach(([key, val]) =>
      key === 'default' || key === '0' || key === 'xsmall'
        ? cellClasses.push(`u-width-${val}/12`)
        : cellClasses.push(`u-width-${val}/12@${key}`),
    );
  }

  if (typeof offset === 'string') {
    cellClasses.push(`u-offset-${offset}/12`);
  } else {
    Object?.entries(offset).forEach(([key, val]) =>
      key === 'default' || key === '0' || key === 'xsmall'
        ? cellClasses.push(`u-offset-${val}/12`)
        : cellClasses.push(`u-offset-${val}/12@${key}`),
    );
  }

  const classes = cx('l-cell', ...cellClasses, className);

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

Cell.propTypes = {
  /**
   * Number of columns (out of 12) to span at different screen sizes -- 1 to 12
   * NOTE: only specify breakpoints when needed since these are inheritted by default!
   */
  columns: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      xsmall: PropTypes.number,
      small: PropTypes.number,
      medium: PropTypes.number,
      large: PropTypes.number,
      xlarge: PropTypes.number,
    }),
  ]),

  /**
   * Number of cells to offset Col from the left, 1 to 12, at different screen sizes
   */
  offset: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      xsmall: PropTypes.number,
      small: PropTypes.number,
      medium: PropTypes.number,
      large: PropTypes.number,
      xlarge: PropTypes.number,
    }),
  ]),

  /**
   * Extend the classNames applied to the component
   */
  className: PropTypes.string,
  children: PropTypes.node,
};

Cell.defaultProps = {
  className: '',
  columns: {
    xsmall: 12,
  },
  offset: {},
};
